var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeOpenIconLogin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_358_3829)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.7345 9.8009C20.0028 8.2009 17.1337 2.9834 10.8837 2.9834C4.63368 2.9834 1.76452 8.2009 1.03285 9.8009C0.93463 10.0153 0.883789 10.2484 0.883789 10.4842C0.883789 10.7201 0.93463 10.9531 1.03285 11.1676C1.76452 12.7659 4.63368 17.9834 10.8837 17.9834C17.1337 17.9834 20.0028 12.7659 20.7345 11.1659C20.8325 10.9517 20.8833 10.7189 20.8833 10.4834C20.8833 10.2479 20.8325 10.0151 20.7345 9.8009ZM10.8837 16.3167C5.62785 16.3167 3.17535 11.8451 2.55035 10.4926C3.17535 9.12173 5.62785 4.65007 10.8837 4.65007C16.127 4.65007 18.5803 9.10256 19.217 10.4834C18.5803 11.8642 16.127 16.3167 10.8837 16.3167Z",
    fill: "#5D5D5D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8835 6.31665C10.0594 6.31665 9.25379 6.56102 8.56859 7.01886C7.88338 7.4767 7.34933 8.12744 7.03397 8.8888C6.7186 9.65016 6.63609 10.4879 6.79686 11.2962C6.95763 12.1044 7.35447 12.8469 7.93719 13.4296C8.51991 14.0123 9.26233 14.4092 10.0706 14.5699C10.8788 14.7307 11.7166 14.6482 12.478 14.3328C13.2393 14.0175 13.8901 13.4834 14.3479 12.7982C14.8058 12.113 15.0501 11.3074 15.0501 10.4833C15.0488 9.37865 14.6094 8.31962 13.8283 7.5385C13.0472 6.75739 11.9881 6.31797 10.8835 6.31665ZM10.8835 12.9833C10.389 12.9833 9.90566 12.8367 9.49454 12.562C9.08342 12.2873 8.76299 11.8968 8.57377 11.44C8.38455 10.9832 8.33504 10.4805 8.4315 9.99559C8.52796 9.51064 8.76607 9.06518 9.1157 8.71555C9.46533 8.36592 9.91079 8.12782 10.3957 8.03135C10.8807 7.93489 11.3834 7.9844 11.8402 8.17362C12.297 8.36284 12.6874 8.68327 12.9621 9.09439C13.2368 9.50551 13.3835 9.98886 13.3835 10.4833C13.3835 11.1464 13.1201 11.7822 12.6512 12.2511C12.1824 12.7199 11.5465 12.9833 10.8835 12.9833Z",
    fill: "#5D5D5D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_358_3829"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.883789 0.483398)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOpenIconLogin);
export default __webpack_public_path__ + "static/media/eyeOpenIconLogin.a385d5fbc4fe0ab0165c0682f048bce8.svg";
export { ForwardRef as ReactComponent };